import React, {Fragment, useState,useEffect} from 'react';
import PageWrapper from "../../components/PageWrapper";
import PageHeader from "../../components/PageHeader";
import ProductContent from "./ProductContent";
import SidebarForProduct from "../SidebarForProduct";

import { useProductPageHeader } from './../../queries/productPageHeader';
import { useParams, useNavigate } from 'react-router-dom';
import InfinitProgressBar from '../../components/InfiniteProgressBar';


const ProductPage = ({sidebar_position,product_type,sidebar}) => {
    const navigate  = useNavigate ();
    const urlData = useParams();

    const [productPagination, setProductPagination] = useState({
        searchText: urlData.searchText,
        products: [],
        currentPage: +(urlData.page),
        productsPerPage: 6,
        total: 0
    });
    const [currentPage, setCurrentPage] = useState(+(urlData.page));
    const [searchPhrase, setSearchPhrase] = useState(urlData.searchText ? urlData.searchText : '');
    const [checked, setChecked] = useState(urlData.searchText ? urlData.searchText.split('_')[1].split('-') : '');
    const productsPage = useProductPageHeader();
    useEffect(() => {
       
        navigate(`/products/${currentPage}${productPagination.searchText ? `/${searchPhrase ? searchPhrase : 'null'}_${checked && checked.length > 0 ? checked.join('-') : 'null'}` : ''}`)
    }, [currentPage, productPagination])
    if(productsPage.loading) return <InfinitProgressBar/>
    if(productsPage.error) return <div>error!</div>
    
console.log(productPagination);
    return (
        <Fragment>
            <PageHeader
                bgImg={productsPage.data.productPageHeader[0].productPageHeaderImage.urls[0]}
                title={productsPage.data.productPageHeader[0].displayText}
                content={productsPage.data.productPageHeader[0].productPageHeaderSubtitle.html}
            />

            <PageWrapper classes={'product-page-content-area sp-y'}>
                {sidebar === true && sidebar_position === 'left' ? <SidebarForProduct checkedSetter={setChecked}  productPagination={productPagination} searchPhrase={searchPhrase} searchPhraseSetter={setSearchPhrase} currentPageSetter={setCurrentPage} currentPage={currentPage} productPaginationSetter={setProductPagination}  classes={'order-1 order-lg-0'}  />  : null}
                  
                 {
                  productPagination.products && productPagination.products.length > 0 ? 
                    <ProductContent productPagination={productPagination} currentPageSetter={setCurrentPage} productPaginationSetter={setProductPagination}  product_type={product_type} cols={sidebar ? 'col-lg-8' : 'col-12'} classes={sidebar_position === 'left' ? 'order-0 order-lg-1':null}/>  
                    :  <div>موردی یافت نشد</div>}
                
                {sidebar === true && sidebar_position === 'right' ? <SidebarForProduct/> : null}
            </PageWrapper>
        </Fragment>
    );
};

export default ProductPage;
